import React from "react";
import { Button, ButtonProps, IconProps } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

interface ColumnDisplayFieldTriggerProps extends ButtonProps {}

const ColumnDisplayFieldTrigger: React.FC<ColumnDisplayFieldTriggerProps> = ({
  iconProps,
  children,
  ...buttonProps
}) => {
  const finalIconProps: IconProps = {
    modifier: "white",
    name: "table-columns",
    title: "Columns",
    ...iconProps
  };

  return (
    <Button modifier="secondary" type="button" iconProps={finalIconProps} {...buttonProps}>
      {children || appstr("Columns")}
    </Button>
  );
};

export default ColumnDisplayFieldTrigger;
